<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VueBarcode from "vue-barcode";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Swal from "sweetalert2";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import MaskedInput from 'vue-text-mask'
// register the plugin on vue
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Toasted from "vue-toasted";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
import moment from "moment";
// import DatePicker from "vue2-datepicker";
import DatePicker from "vuejs-datepicker";
import "vue-select/dist/vue-select.css";
import {  es } from "vuejs-datepicker/dist/locale";
/**
 * Categoria component
 */
export default {
  page: {
    title: "Cerdos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Loader,
    barcode: VueBarcode,
    'masked-input': MaskedInput,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      es: es,
      razasDeCerdos : [
        { nombre: "Duroc" },
      { nombre: "Tri-Linea" },
    { nombre: "Landrace" },
    { nombre: "Pietrain" },
    { nombre: "Hampshire" },
    { nombre: "Chester White" },
    { nombre: "TN60" },
    { nombre: "TN70" },
      ],
      repit_codigo: true,
      totalAnimales: 0,
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "cerdos/get",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      mask_quetzal: createNumberMask({
          prefix: "Q ",
          suffix: "",
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ",",
          allowDecimal: true,
          decimalSymbol: ".",
          decimalLimit: 2, // how many digits allowed after the decimal
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false,
          allowLeadingZeroes: false,
      }),
      formCerdo: {
        nombre: "",
        tipo_animal: "",
        precio_compra: "0",
        semanas: "",
        raza : "",
        peso_ingreso: "",
        peso_actual: "",
        fecha_ingreso: "",
        partos: 0,
        codigo : "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Cerdos",
      itemst: [
        {
          text: "Cerdos",
          href: "/",
        },
        {
          text: "Cerdos",
          active: true,
        },
      ],
      fields: [
        {
          name: "codigo",
          title: "Código",
          sortField: "codigo",
          width: "10%",
        },
        {
          name: "semanas",
          title: "Semanas",
          sortField: "semanas",
          width: "10%",
        },
        
        {
          name: "raza",
          title: "Raza ",
          sortField: "raza",
          width: "10%",
        },
      
        {
          name: "fecha_ingreso",
          title: "Fecha Ingreso",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        
        {
          name: "precio_compra",
          title: "Precio compra LB",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "estado_animal",
          title: "Animal",
          sortField: "estado_animal",
          width: "10%",
        },
        {
          name: "tipo_animal.nombre",
          title: "Tipo Animal",
          sortField: "tipo_animal.nombre",
          width: "10%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [{ nombre: "Codigo", value: "codigo" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "codigo",
      sortDesc: false,
      searchLabel: { nombre: "Codigo", value: "codigo" },
      filterLabel: { nombre: "Codigo", value: "codigo" },
      showModalL: false,
      showModalN: false,
      showModalD: false,
      showModalA: false,
      showModalE: false,
      submitted: false,
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      dataSelect : [],
      totalAnimalesHijos: 0,
      cerdosHijosEngorde: 0,
      animalesVendidos: 0,
    };
  },
  validations: {
    formCerdo: {
        
      tipo_animal: {required },
      precio_compra: { required },
      codigo: {required},
      peso_actual: {required},
      peso_ingreso: {required},
      fecha_ingreso: {required},
      raza: {required},
      semanas: {required},
      partos: {required}
    },
  },
  mounted() {
    this.getAllInversion();
    const usuario = this.$store.state.authfack.user;
    this.selectTipoAnimal();
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    async selectTipoAnimal() {
      let me = this;
      this.dataSelect = [];
      const response = await axios.get(this.apiUrl + "tipo_animal/select", {
        headers: {"x-token": this.userT.token},
      });
      // console
      me.dataSelect = response.data.data;
      // console.log( me.dataSelect )
    },
    //modal y validaciones
    limpiarModal() {
      this.formCerdo.id = 0;
      this.formCerdo.tipo_animal = "";
      this.formCerdo.precio_compra = "";
      this.formCerdo.peso_ingreso = "";
      this.formCerdo.peso_actual = "";
      this.formCerdo.fecha_ingreso = "";
      this.formCerdo.codigo = "";
      this.formCerdo.partos ="";
    },
    validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid

      this.$v.$touch();
      // console.log(this.$v.$invalid, this.repit);
      if (this.$v.$invalid) {
        console.log('hola')
        return;
      } else {
        console.log('aca')
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, codigo } = this.formCerdo;
      axios
        .put(process.env.VUE_APP_URL + "cerdos/desactivate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(codigo + " Desactivado", this.options);

          const currentPage = this.$refs.vuetable.tablePagination.currentPage;
          this.$refs.vuetable.changePage(currentPage); 

        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //ACtivar registro
    activate() {
      const { id, codigo } = this.formCerdo;
      axios
        .put(process.env.VUE_APP_URL + "cerdos/activate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(codigo + " Activado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    convertMaskToNumber(value) {
      var myNumber = "";
      for (var i = 0; i < value.length; i += 1) {
        if (
          value.charAt(i) === "Q" ||
          value.charAt(i) === "," ||
          value.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += value.charAt(i);
        }
      } 
      return parseFloat(myNumber).toFixed(2);
    },
    //Guardar registro
    save() {
      // console.log(partos)
      const {  tipo_animal, precio_compra,  codigo, peso_ingreso, peso_actual, fecha_ingreso,raza,semanas, partos } = this.formCerdo;
      const me = this;
      axios
        .post(process.env.VUE_APP_URL + "cerdos/store", {
        codigo,
        tipoAnimalId: tipo_animal.id,raza : raza.nombre,semanas,partos,
          precio_compra: parseFloat(me.convertMaskToNumber(precio_compra)),
          peso_ingreso, peso_actual,
           fecha_ingreso : this.customFormatter(fecha_ingreso),
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(codigo + " Guardado", this.options);
          
          this.showModalN = false;
          this.limpiarModal();
          this.submitted = false;
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const {  tipo_animal, precio_compra, peso_ingreso,peso_actual,fecha_ingreso, codigo, id, raza ,semanas , partos} = this.formCerdo;
      const me = this;
      axios
        .put(process.env.VUE_APP_URL + "cerdos/update", {
          id: id,raza :  raza.nombre,semanas,partos,
          peso_ingreso,peso_actual,
          fecha_ingreso : this.customFormatter(fecha_ingreso),
          tipoAnimalId: tipo_animal.id,
          codigo,
          precio_compra: parseFloat(me.convertMaskToNumber(precio_compra)),
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(codigo + " Actualizado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)

          this.showModalE = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    async getAllInversion() {
      // console.log('hola')
      const response = await axios.get(
        process.env.VUE_APP_URL + "cerdos/get_total",
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.totalAnimales = response.data.data[0];
      this.totalAnimalesHijos = response.data.data[1];
      this.cerdosHijosEngorde = response.data.data[2];
      this.animalesVendidos = response.data.data[3];
      // console.log(   response);
    },
    //Timer de registro guardado para notificacion
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "I will close in <b></b> milliseconds.",
        timer: 2000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector("b").textContent =
              Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      // console.log(this.items)
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      // console.log(sortOrder,currentPage)
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    
    customFormatter(date) {
  return moment(date).utc().format("YYYY-MM-DD"); // Forzar UTC para evitar desfase
},

    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    formatoPresentacion(date) {
  return moment(date, "YYYY-MM-DD").locale("es").format("LL"); // Forzar formato sin hora
},

    //Para abrir los modales y pasar los datos de la fila
    onActionClicked(action, data) {
        console.log(data);
      if (action == "edit-item") {
        this.formCerdo.tipo_animal = data.tipo_animal;
        this.formCerdo.codigo = data.codigo;
        this.formCerdo.precio_compra = data.precio_compra;
        this.formCerdo.peso_ingreso = data.peso_ingreso;
        this.formCerdo.peso_actual = data.peso_actual;
        this.formCerdo.fecha_ingreso = (data.fecha_ingreso);
        this.formCerdo.partos = data.partos;
        console.log(     this.formCerdo.fecha_ingreso);
        this.formCerdo.semanas = data.semanas;
        this.formCerdo.raza = data.raza;
        this.formCerdo.id = data.id;
        this.showModalE = true;
      }
      if (action == "new-item") {
        this.formCerdo.tipo_animal = "";
        this.formCerdo.codigo = "";
        this.formCerdo.precio_compra = "";
        this.formCerdo.raza = "";
        this.formCerdo.seamanas = "";
        this.formCerdo.peso_ingreso = "";
        this.formCerdo.peso_actual = "";
        this.formCerdo.fecha_ingreso = "";
        this.formCerdo.partos = 0;
        this.showModalN = true;
      }
      if (action == "desactivate-item") {
        this.formCerdo.codigo = data.codigo;
        this.formCerdo.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formCerdo.codigo = data.codigo;
        this.formCerdo.id = data.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar cerdo"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar la Cerdo?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar la Cerdo?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

       <!-- Modal para Editar-->
       <b-modal
          centered
          v-model="showModalE"
          title="Editar Cerdo"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('update')">
            <div class="row">
                <div class="col-12">
                <div class="mb-3">
                  <label>Tipo Animal</label>
                  <v-select
                      v-model.trim="$v.formCerdo.tipo_animal.$model"
                      :state="!$v.formCerdo.tipo_animal.$error"
                      :options="dataSelect"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formCerdo.tipo_animal.$error && !$v.formCerdo.tipo_animal.required,
                    }"
                  >
                    Debe seleccionar un tipo animal
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Raza Animal</label>
                  <v-select
                      v-model.trim="$v.formCerdo.raza.$model"
                      :state="!$v.formCerdo.raza.$error"
                      :options="razasDeCerdos"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formCerdo.raza.$error && !$v.formCerdo.raza.required,
                    }"
                  >
                    Debe seleccionar una raza de animal
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Fecha Ingreso</label>
                  <date-picker
                            v-model.trim="$v.formCerdo.fecha_ingreso.$model"
                            :state="!$v.formCerdo.fecha_ingreso.$error"

                            styling="true"
                            :format="customFormatter"
                             input-class="form-control"
                             :language="es"
                              lang="es"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formCerdo.fecha_ingreso.$error &&
                                !$v.formCerdo.fecha_ingreso.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                </div>
              </div>
    
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Código</label>
                  <input
                              id="name"
                              v-model="$v.formCerdo.codigo.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un Codigo"
                              :class="{
                                'is-invalid': $v.formCerdo.codigo.$error,
                              }"
                              @input="$v.formCerdo.codigo.$touch()"
                            />
                            <div
                              v-if="  $v.formCerdo.codigo.$error &&!$v.formCerdo.codigo.required
                              "
                              class="invalid-feedback"
                            >
                              El Codigo es obligatorio.
                            </div>
                            
                     
                      <barcode :value="formCerdo.codigo" :options="{ format: 'EAN13' }">
                          generando código de barras
                      </barcode>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Peso ingreso Lb</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.peso_ingreso.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un peso ingreso"
                    :class="{
                      'is-invalid': $v.formCerdo.peso_ingreso.$error,
                    }"
                    @input="$v.formCerdo.peso_ingreso.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.peso_ingreso.$error &&
                      !$v.formCerdo.peso_ingreso.required
                    "
                    class="invalid-feedback"
                  >
                    El peso ingreso es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Semanas de vida</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.semanas.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese las semanas de vida"
                    :class="{
                      'is-invalid': $v.formCerdo.semanas.$error,
                    }"
                    @input="$v.formCerdo.semanas.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.semanas.$error &&
                      !$v.formCerdo.semanas.required
                    "
                    class="invalid-feedback"
                  >
                    Ingrese las semanas de vida.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Peso actual Lb</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.peso_actual.$model"
                    type="tex"
                    class="form-control"
                    placeholder="Ingrese un peso actual"
                    :class="{
                      'is-invalid': $v.formCerdo.peso_actual.$error,
                    }"
                    @input="$v.formCerdo.peso_actual.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.peso_actual.$error &&
                      !$v.formCerdo.peso_actual.required
                    "
                    class="invalid-feedback"
                  >
                    El peso actual es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Precio compra</label>
                  <masked-input
                              v-model="$v.formCerdo.precio_compra.$model"
                              :state="!$v.formCerdo.precio_compra.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formCerdo.precio_compra.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formCerdo.precio_compra.$error &&!$v.formCerdo.precio_compra.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio compra es obligatorio.
                            </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Partos</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.partos.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese numero de partos"
                    :class="{
                      'is-invalid': $v.formCerdo.partos.$error,
                    }"
                    @input="$v.formCerdo.partos.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.partos.$error &&
                      !$v.formCerdo.partos.required
                    "
                    class="invalid-feedback"
                  >
                    El numero de partos es obligatorio.
                  </div>
                </div>
              </div>
            </div>
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

      <!-- Modal de Nuevo Registro-->
      <b-modal
          centered
          v-model="showModalN"
          title="Nuevo Ingreso"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('save')">
            <div class="row">
                <div class="col-12">
                <div class="mb-3">
                  <label>Tipo Animal</label>
                  <v-select
                      v-model.trim="$v.formCerdo.tipo_animal.$model"
                      :state="!$v.formCerdo.tipo_animal.$error"
                      :options="dataSelect"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formCerdo.tipo_animal.$error && !$v.formCerdo.tipo_animal.required,
                    }"
                  >
                    Debe seleccionar un tipo animal
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Raza Animal</label>
                  <v-select
                      v-model.trim="$v.formCerdo.raza.$model"
                      :state="!$v.formCerdo.raza.$error"
                      :options="razasDeCerdos"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formCerdo.raza.$error && !$v.formCerdo.raza.required,
                    }"
                  >
                    Debe seleccionar una raza de animal
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Fecha Ingreso</label>
                  <date-picker
                            v-model.trim="$v.formCerdo.fecha_ingreso.$model"
                            :state="!$v.formCerdo.fecha_ingreso.$error"
                            input-class="form-control"
                            :bootstrap-styling="true"
                            :language="es"
                            lang="es"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formCerdo.fecha_ingreso.$error &&
                                !$v.formCerdo.fecha_ingreso.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                </div>
              </div>
         
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Código</label>
                  <input
                              id="name"
                              v-model="$v.formCerdo.codigo.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un Codigo"
                              :class="{
                                'is-invalid': $v.formCerdo.codigo.$error,
                              }"
                              @input="$v.formCerdo.codigo.$touch()"
                            />
                            <div
                              v-if="  $v.formCerdo.codigo.$error &&!$v.formCerdo.codigo.required
                              "
                              class="invalid-feedback"
                            >
                              El Codigo es obligatorio.
                            </div>
                            
                     
                      <barcode :value="formCerdo.codigo" :options="{ format: 'EAN13' }">
                          generando código de barras
                      </barcode>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Semanas de vida</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.semanas.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese las semanas de vida"
                    :class="{
                      'is-invalid': $v.formCerdo.semanas.$error,
                    }"
                    @input="$v.formCerdo.semanas.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.semanas.$error &&
                      !$v.formCerdo.semanas.required
                    "
                    class="invalid-feedback"
                  >
                    Ingrese las semanas de vida.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Peso ingreso Lb</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.peso_ingreso.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un peso ingreso"
                    :class="{
                      'is-invalid': $v.formCerdo.peso_ingreso.$error,
                    }"
                    @input="$v.formCerdo.peso_ingreso.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.peso_ingreso.$error &&
                      !$v.formCerdo.peso_ingreso.required
                    "
                    class="invalid-feedback"
                  >
                    El peso ingreso es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Peso actual Lb</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.peso_actual.$model"
                    type="tex"
                    class="form-control"
                    placeholder="Ingrese un peso actual"
                    :class="{
                      'is-invalid': $v.formCerdo.peso_actual.$error,
                    }"
                    @input="$v.formCerdo.peso_actual.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.peso_actual.$error &&
                      !$v.formCerdo.peso_actual.required
                    "
                    class="invalid-feedback"
                  >
                    El peso actual es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Precio compra</label>
                  <masked-input
                              v-model="$v.formCerdo.precio_compra.$model"
                              :state="!$v.formCerdo.precio_compra.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formCerdo.precio_compra.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formCerdo.precio_compra.$error &&!$v.formCerdo.precio_compra.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio compra es obligatorio.
                            </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Partos</label>
                  <input
                    id="name"
                    v-model="$v.formCerdo.partos.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese numero de partos"
                    :class="{
                      'is-invalid': $v.formCerdo.partos.$error,
                    }"
                    @input="$v.formCerdo.partos.$touch()"
                  />
                  <div
                    v-if="
                      $v.formCerdo.partos.$error &&
                      !$v.formCerdo.partos.required
                    "
                    class="invalid-feedback"
                  >
                    El numero de partos es obligatorio.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Cerdos</h4>
            <div class="row">
  <div class="col-sm-12 text-md-end">
    <!-- <div
      v-if="userT.role == 1 || userT.role == '1'"
      class="mt-2 p-3 d-flex justify-content-center align-items-center"
      style="background-color: #f0f8ff; border: 1px solid #d1e7dd; border-radius: 8px;"
    >
      <div class="me-3">
        <strong class="text-primary" style="font-size: 1.5rem;">Total Madre: </strong>
        <span class="text-success" style="font-size: 1.5rem;">{{ (totalAnimales) }}</span>
      </div>
      <div class="me-3">
        <strong class="text-primary" style="font-size: 1.5rem;">Total Lechones: </strong>
        <span class="text-success" style="font-size: 1.5rem;">{{ (totalAnimalesHijos) }}</span>
      </div>
      <div class="me-3">
        <strong class="text-primary" style="font-size: 1.5rem;">Total Cerdo Engorde: </strong>
        <span class="text-success" style="font-size: 1.5rem;">{{ (cerdosHijosEngorde) }}</span>
      </div>
      <div class="me-3">
        
        <strong class="text-primary" style="font-size: 1.5rem;">Total Cerdo Vendidos: </strong>
        <span class="text-success" style="font-size: 1.5rem;">{{ (animalesVendidos) }}</span>
      </div>
    </div> -->
  </div>
</div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="changeTypeSearch(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nuevo Animal
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :http-options="httpOptions"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <!-- <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button> -->
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="precio_compra" slot-scope="props">
                  {{
                    money(props.rowData.precio_compra)
                  }}
                </div>
                <div slot="fecha_ingreso" slot-scope="props">
                  {{
                    formatoPresentacion(props.rowData.fecha_ingreso)
                  }}
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>./cerdos.vue
